import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import { useCustomHooks } from "../../../../functions/Hooks";
import { useGeneralHooks } from "../../../../hooks/generalHooks";
//functions
import {
  _t,
  getCookie,
  tableLoading,
  getSystemSettings,
  customStyle,
  getMinDateByTime,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from 'moment';
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const SalesSummaryReport = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { roundFormatPrice, roundOffPrice } = useCustomHooks();
  const { salesListingKey } = useGeneralHooks();

  const inputProps = {
    placeholder: 'To Time',
  };

  const inputProp = {
    placeholder: 'From Time',
  };
  //getting context values here
  let { loading, setLoading, dataPaginating, generalSettings } = useContext(SettingsContext);
  let { branchForSearch, orderTypeList, paymentTypeForSearch } = useContext(RestaurantContext);
  const { partyForSearch, authUserInfo } = useContext(UserContext);

  let [newSalesSummaryReport, setNewSalesSummaryReport] = useState(null);

  //all data
  const [reportData, setReportData] = useState(null);
  const [zReportData, setZReportData] = useState(null);
  const [branchReportData, setBranchReportData] = useState(null);
  const [branchDeliveryTypeReportData, setBranchDeliveryTypeReportData] = useState(null);
  const [branchTypeReportData, setBranchTypeReportData] = useState(null);
  const [branchTakewayTypeReportData, setBranchTakewayReportData] = useState(null);
  const [branchDineTypeReportData, setBranchDineReportData] = useState(null);
  const [dailyBillReportData, setDailyBillReportData] = useState(null);

  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRefThermal = useRef();
  const componentRefThermalDaily = useRef();
  const componentRefThermalDetail = useRef();

  const [time,setTime] = useState({
    fromTime: null,
    toTime: null,
    key: false,
  });

  const groupByArray = [
    { id: "Branch", name: "Branch" },
    { id: "Order Types", name: "Order Types" },
    { id: "Payment Types", name: "Payment Types" },
  ];
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("sales_summary_report");
  const [reportOption,setReportOption] = useState("excel");
  // const [sumPrice, setSumPrice] = useState(0);
  // const [sumTotalPrice, setSumTotalPrice] = useState(0);
  const [siteName, setSiteName] = useState("");

  //useEffect == componentDidMount()

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  const handleOption  = (e) =>{
    setOption(e.target.value);
    if(e.target.value === "daily_bill_summary"){
      setNewSalesSummaryReport({ ...newSalesSummaryReport, branch: null});
    }
  }

  const handleReportOption  = (e) =>{
    setReportOption(e.target.value);
    setNewSalesSummaryReport({ ...newSalesSummaryReport, party: null });
  }

  const handleBranch = (branch) => {
    setNewSalesSummaryReport({ ...newSalesSummaryReport, branch });
    // setBranch(branch);
  };
  const handleGroup = (group) => {
    setNewSalesSummaryReport({ ...newSalesSummaryReport, group });
    //setGroup(group);
  };
  const handleItem = (item) => {
    setNewSalesSummaryReport({ ...newSalesSummaryReport, item });
    //setItem(item);
  };
  const handleParty = (party) => {
    setNewSalesSummaryReport({ ...newSalesSummaryReport, party });
    //setParty(party);
  };
  const handleOrderTypes = (orderTypes) => {
    setNewSalesSummaryReport({ ...newSalesSummaryReport, orderTypes });
    //setOrderTypes(orderTypes);
  };
  const handlePaymentTypes = (paymentTypes) => {
    setNewSalesSummaryReport({ ...newSalesSummaryReport, paymentTypes });
    //setPaymentTypes(paymentTypes);
  };
  const handleGroupBy = (groupBy) => {
    setNewSalesSummaryReport({ ...newSalesSummaryReport, groupBy });
    //setGroupBy(groupBy);
  };

  //get BranchWise reports filter
  const getSalesListing = () => {
    setReportData(null);
    if (
      startDate !== null &&
      endDate !== null
    ) {
      setLoading(true);
      const fromDate = moment(startDate).format("YYYY-MM-DD");
      const toDate =  moment(endDate).format("YYYY-MM-DD");
      const branch = (newSalesSummaryReport?.branch && newSalesSummaryReport?.branch?.length) ? JSON.stringify(newSalesSummaryReport?.branch.map((branch)=>branch.id)) : "";

      const url = BASE_URL + "/sales-listing";
      let formData = new FormData();
      formData.append("from_date", fromDate);
      formData.append("to_date", toDate);
      formData.append("branch_id", branch);
      formData.append("key", salesListingKey);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          history.push({
            pathname: '/sales-listing',
            state: { data: res.data },
          });
          setLoading(false);
          setTime({
            fromTime:null,
            toTime:null,
            key: !time.key,
          })

        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select from date, to date to generate report"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  const thermalPrintDetail = useReactToPrint({
    content: () => componentRefThermalDetail.current,
    pageStyle: `@page {margin: 5px;}`,
  });

  //get BranchWise reports filter
  const getBranchWiseSelected = () => {
    setReportData(null);
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !newSalesSummaryReport?.branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select Branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    if (
      // newSalesSummaryReport?.branch?.id !== null &&
      startDate !== null &&
      endDate !== null &&
      newSalesSummaryReport?.groupBy?.id
    ) {
      setLoading(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate =  moment(endDate).format("YYYY-MM-DD");
      let  fromTime = time.fromTime ? time.fromTime.format('HH:mm A') : null;
      let toTime = time.toTime ? time.toTime.format('HH:mm A') : null;

      const url = BASE_URL + "/settings/get-sales-summary-report";
      const branch = (newSalesSummaryReport?.branch && newSalesSummaryReport?.branch?.length) ? JSON.stringify(newSalesSummaryReport?.branch.map((branch)=>branch.id)) : undefined;
      const party = (newSalesSummaryReport?.party && newSalesSummaryReport.party?.length) ? JSON.stringify(newSalesSummaryReport?.party.map((party)=>party.id)) : undefined;

      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("fromTime", fromTime);
      formData.append("toTime", toTime);
      formData.append("branch_id", branch);
      formData.append("order_type_id", newSalesSummaryReport?.orderTypes?.id);
      formData.append("party_id", party);
      formData.append(
        "payment_type_name",
        newSalesSummaryReport?.paymentTypes?.name
      );
      formData.append("group_by", newSalesSummaryReport?.groupBy?.id);

      console.log("formData ", formData);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("SalesSummaryReportResult", res);
          setReportData(res.data[0]);
          setGeneratedReport(true);
          if(reportOption === "print"){
            thermalPrintDetail();
          }else{
            console.log("Component ", componentRef);
            componentRef.current.handleDownload();
          }
          setNewSalesSummaryReport(null);
          setTime({
            fromTime:null,
            toTime:null,
            key: !time.key,
          })
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          if(error.response?.data?.status === 0){
            toast.error(
              `${_t(t(error.response.data?.message))}`,
              {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );
            return;
          }
        });
    } else {
      toast.error(
        `${_t(
          t("Please select from date, to date, branch and report group to generate report")
        )}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  //get BranchWise reports filter
  const getBranchWiseSaleSummary = () => {
    setBranchReportData(null);
    setBranchDeliveryTypeReportData(null);
    setBranchTypeReportData(null);
    setBranchTakewayReportData(null);
    setBranchDineReportData(null)

    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") && 
      !newSalesSummaryReport?.branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select Branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    if (
      // newSalesSummaryReport?.branch?.id !== null &&
      startDate !== null &&
      endDate !== null &&
      newSalesSummaryReport?.groupBy?.id
    ) {
      setLoading(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate =  moment(endDate).format("YYYY-MM-DD");
      let  fromTime = time.fromTime ? time.fromTime.format('HH:mm A') : null;
      let toTime = time.toTime ? time.toTime.format('HH:mm A') : null;
      const branch = (newSalesSummaryReport?.branch && newSalesSummaryReport?.branch?.length) ? JSON.stringify(newSalesSummaryReport?.branch.map((branch)=>branch.id)) : undefined;

      const url = BASE_URL + "/settings/get-branch-sales-report";
      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("fromTime", fromTime);
      formData.append("toTime", toTime);
      formData.append("branch_id", branch);
      formData.append("order_type_id", newSalesSummaryReport?.orderTypes?.id);
      formData.append("party_id", newSalesSummaryReport?.party?.id);
      formData.append(
        "payment_type_name",
        newSalesSummaryReport?.paymentTypes?.name
      );
      formData.append("group_by", newSalesSummaryReport?.groupBy?.id);

      console.log("formData ", formData);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setBranchReportData(res.data[0]);
          setBranchTypeReportData(res.data[1]);
          setBranchDeliveryTypeReportData(res.data[2]);
          setBranchTakewayReportData(res.data[3]);
          setBranchDineReportData(res.data[4]);
          setLoading(false);
          setGeneratedReport(true);
          componentRef1.current.handleDownload();
          setNewSalesSummaryReport(null);
          setTime({
            fromTime:null,
            toTime:null,
            key: !time.key,
          })
        })
        .catch((error) => {
          setLoading(false);
          if(error.response?.data?.status === 0){
            toast.error(
              `${_t(t(error.response.data?.message))}`,
              {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );
            return;
          }
        });
    } else {
      toast.error(
        `${_t(
          t("Please select from date, to date, branch and report group to generate report")
        )}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
  });

  const thermalDailyPrint = useReactToPrint({
    content: () => componentRefThermalDaily.current,
    pageStyle: `@page { margin: 10px; }`,
  });

  //get BranchWise reports filter
  const getThermalSelected = () => {
    setReportData(null);
    
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !newSalesSummaryReport?.branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select Branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    if (
      // newSalesSummaryReport?.branch?.id !== null &&
      startDate !== null &&
      endDate !== null &&
      newSalesSummaryReport?.groupBy?.id
    ) {
      setLoading(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate =  moment(endDate).format("YYYY-MM-DD");
      let  fromTime = time.fromTime ? time.fromTime.format('HH:mm A') : null;
      let toTime = time.toTime ? time.toTime.format('HH:mm A') : null;
      const branch = (newSalesSummaryReport?.branch && newSalesSummaryReport?.branch?.length) ? JSON.stringify(newSalesSummaryReport?.branch.map((branch)=>branch.id)) : undefined;

      const url = BASE_URL + "/settings/get-boc-sales-report";
      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("fromTime", fromTime);
      formData.append("toTime", toTime);
      formData.append("branch_id", branch);
      formData.append("order_type_id", newSalesSummaryReport?.orderTypes?.id);
      formData.append("party_id", newSalesSummaryReport?.party?.id);
      formData.append(
        "payment_type_name",
        newSalesSummaryReport?.paymentTypes?.name
      );
      formData.append("group_by", newSalesSummaryReport?.groupBy?.id);

      console.log("formData ", formData);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setZReportData(res.data[0])
          setLoading(false);
          thermalPrint();
          setNewSalesSummaryReport(null);
          setTime({
            fromTime:null,
            toTime:null,
            key: !time.key,
          })
        })
        .catch((error) => {
          setLoading(false);
          if(error.response?.data?.status === 0){
            toast.error(
              `${_t(
                t(error.response?.data?.message)
              )}`,
              {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );
            return
          }
        });
    } else {
      toast.error(
        `${_t(
          t("Please select from date, to date, branch and report group to generate report")
        )}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  const getDailyBillSummary = () =>{
    setDailyBillReportData(null);

    if (
      startDate !== null &&
      endDate !== null &&
      newSalesSummaryReport?.branch?.id
    ) {
      setLoading(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      let fromTime = time.fromTime ? time.fromTime.format('HH:mm A') :"";
      let toTime = time.toTime ? time.toTime.format('HH:mm A') : "";

      const url = BASE_URL + "/settings/get-daily-bill-summary-report";
      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("fromTime", fromTime);
      formData.append("toTime", toTime);
      formData.append("branch_id", newSalesSummaryReport?.branch?.id || "");
      formData.append("order_type_id", newSalesSummaryReport?.orderTypes?.id || "");
      formData.append("party_id", newSalesSummaryReport?.party?.id || "");

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setDailyBillReportData(res.data);
          setLoading(false);
          thermalDailyPrint();
          setTime({
            fromTime:null,
            toTime:null,
            key: !time.key,
          })
        })
        .catch((error) => {
          setLoading(false);
          if(error.response?.data?.status === 0){
            toast.error(
              `${_t(t(error.response.data?.message))}`,
              {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );
            return;
          }
        });
    } else {
      toast.error(
        `${_t(
          t("Please select from date, to date, branch and report group to generate report")
        )}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  }

  const handleCheckReport = (e) =>{
    e.preventDefault();
    if(option === "thermal_report"){
      getThermalSelected()
    }else if(option === "sales_data"){
      getSalesListing()
    }else if(option === "branch_wise_report"){
      getBranchWiseSaleSummary()
    }else if(option === "daily_bill_summary"){
      getDailyBillSummary()
    }else{
      getBranchWiseSelected()
    }
  }

  let total = [];

  const calculateTotal = (value,index) =>{
    if((typeof (value) === 'number')){
      total[index] = (total[index] || 0) + value;
    }
  }

  
  let total_price = 0;
  let grand_total = 0;
  let g_tax = 0 ;
  let g_discount = 0
  let g_delCharges = 0;
  let g_serCharges = 0;
  let g_afterDiscount = 0;
  let g_order_tip = 0;
  let g_pos_fee = 0;
  let g_total_guest = 0;

  let grandOrderBill = 0;
  let grandTotalTax = 0;
  let grandTotal = 0;

  ///print totals
  let salesAvg = 0;
  let salesAmount = 0;
  let salesCount = 0;
  let disUnclaimAvg = 0;
  let salesBreakUp = 0;
  let disUnclaimAmount = 0;
  let disUnclaimCount = 0;
  let disAvg = 0;
  let disAmount = 0;
  let disCount = 0;
  let tenderAvg = 0;
  let tenderAmount = 0;
  let tenderCount = 0;
  let saleTypeAvg = 0;
  let saleTypeAmount = 0;
  let saleTypeCount = 0;
  let deliveryAvg = 0;
  let deliveryAmount = 0;
  let deliveryCount = 0;
  let paymentModeAvg = 0;
  let paymentModeAmount = 0;
  let paymentModeCount = 0;

  //daily sales
  let grossAmount = 0;
  let discount = 0;
  let serviceCharge = 0;
  let deliveryCharges = 0;
  let tax= 0; 
  let totalPayable = 0;
  let paymentTypeWise = {};

  return (
    <>
      <Helmet>
        <title>{_t(t("Sales Summary Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Sales Summary Report"
        sheet="sheet 1"
        buttonText="Sales Detail"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-sale"
        filename="Sales Summary Branch Report"
        sheet="sheet 1"
        buttonText="Sale Detail"
        ref={componentRef1}
      />

      {/* Print branch wise Button */}
      <div className="d-none">
        {branchReportData !== null && branchReportData &&
          branchReportData !== undefined &&
          generatedReport === true && (
            <>
              <table
                className="table table-bordered"
                id="table-to-sale"
              >
                <thead className="align-middle">
                  <tr style={{ border: "0px" }}>
                    <th colspan={Object.keys(branchReportData[0])?.length || "14"} style={{ border: "0px" }}>
                      <div className="row">
                        <div className="col-12">
                          <h3 className="text-center mb-0">
                            {siteName}
                          </h3>
                          <h3 className="text-center mt-0">
                            Sales Summary Branch Wise Report
                          </h3>
                          <p className="text-center">
                            FROM&nbsp;
                            <Moment format="LL">
                              {startDate}
                            </Moment>
                            &nbsp;TO&nbsp;
                            <Moment format="LL">{endDate}</Moment>
                          </p>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    {branchReportData?.length &&
                      Object.keys(branchReportData[0]).map((name) =>{
                        return (
                          <th
                            scope="col"
                          >
                            {_t(t(name))}
                          </th>
                        )
                      })
                    }
                  </tr>
                </thead>
                <tbody className="align-middle">
                  
                  {/* loop here*/}
                  {branchReportData?.length && branchReportData.map((item) => {
                      return (
                        <tr>
                          {
                            Object.keys(branchReportData[0]).map((name,index)=>{
                              if(index > 0){
                                calculateTotal(parseFloat(item[name]),index-1)
                              }
                              return (
                                <td
                                  scope="row"
                                >
                                  {item[name]}
                                </td>
                              )
                            })
                          }
                        </tr>
                      );
                    }
                  )}
                  <tr>
                    <th>
                      Total
                    </th>
                    {
                      total && total.map(item =>{
                        return (
                          <td>
                            {roundFormatPrice(item)}
                          </td>
                        )
                      })
                    }
                  </tr>

                  <tr></tr>

                  <tr>
                    <th>
                      Service Type
                    </th>
                    <th>
                      No of Invoice
                    </th>
                    <th>
                      Net Amount
                    </th>
                  </tr>
                  {(() => {
                    total = []; 
                    return branchTypeReportData && branchTypeReportData.map((item) =>{
                      calculateTotal(parseFloat(item["Total Orders"]),0);
                      calculateTotal(parseFloat(item["Net Sales"]),1)

                      return (
                        <tr>
                          <th>
                            {item["Type"]}
                          </th>
                          <td>
                            {item["Total Orders"]}
                          </td>
                          <td>
                            {item["Net Sales"]}
                          </td>
                        </tr>
                      )

                    })
                  })()}

                  <tr>
                    <th>
                      Total
                    </th>
                    {
                      total && total.map(item =>{
                        return (
                          <td>
                            {roundFormatPrice(item)}
                          </td>
                        )
                      })
                    }
                  </tr>

                  <tr></tr>

                  <tr>
                    <th>
                      Delivery Channel
                    </th>
                    <th>
                      No of Invoice
                    </th>
                    <th>
                      Net Amount
                    </th>
                  </tr>

                  {(() => {
                    total = [];
                    return branchDeliveryTypeReportData && branchDeliveryTypeReportData.map((item) =>{
                      calculateTotal(parseFloat(item["Total Orders"]),0);
                      calculateTotal(parseFloat(item["Net Sales"]),1)

                      return (
                        <tr>
                          <th>
                            {item["Party Type"]}
                          </th>
                          <td>
                            {item["Total Orders"]}
                          </td>
                          <td>
                            {item["Net Sales"]}
                          </td>
                        </tr>
                      )
                    })
                  })()}

                  <tr>
                    <th>
                      Total
                    </th>
                    {
                      total && total.map(item =>{
                        return (
                          <td>
                            {roundFormatPrice(item)}
                          </td>
                        )
                      })
                    }
                  </tr>

                  <tr></tr>

                  <tr>
                    <th>
                      Takeaway Channel
                    </th>
                    <th>
                      No of Invoice
                    </th>
                    <th>
                      Net Amount
                    </th>
                  </tr>

                  {(() => {
                    total = []; 
                    return branchTakewayTypeReportData && branchTakewayTypeReportData.map((item) =>{
                      calculateTotal(parseFloat(item["Total Orders"]),0);
                      calculateTotal(parseFloat(item["Net Sales"]),1)

                      return (
                        <tr>
                          <th>
                            {item["Party Type"]}
                          </th>
                          <td>
                            {item["Total Orders"]}
                          </td>
                          <td>
                            {item["Net Sales"]}
                          </td>
                        </tr>
                      )
                    })
                  })()}

                  <tr>
                    <th>
                      Total
                    </th>
                    {
                      total && total.map(item =>{
                        return (
                          <td>
                            {roundFormatPrice(item)}
                          </td>
                        )
                      })
                    }
                  </tr>

                  <tr></tr>
                  
                  <tr>
                    <th>
                      Dine-In Channel
                    </th>
                    <th>
                      No of Invoice
                    </th>
                    <th>
                      Net Amount
                    </th>
                  </tr>

                  {(() => {
                    total = []; 
                    return branchDineTypeReportData && branchDineTypeReportData.map((item) =>{
                      calculateTotal(parseFloat(item["Total Orders"]),0);
                      calculateTotal(parseFloat(item["Net Sales"]),1)

                      return (
                        <tr>
                          <th>
                            {item["Party Type"]}
                          </th>
                          <td>
                            {item["Total Orders"]}
                          </td>
                          <td>
                            {item["Net Sales"]}
                          </td>
                        </tr>
                      )
                    })
                  })()}

                  <tr>
                    <th>
                      Total
                    </th>
                    {
                      total && total.map(item =>{
                        return (
                          <td>
                            {roundFormatPrice(item)}
                          </td>
                        )
                      })
                    }
                  </tr>
                    
                </tbody>
              </table>
            </>
        )}
      </div>       

      {/* thermal print */}
      <div className="d-none">
        <div ref={componentRefThermal}>
          {
            zReportData !== null && (
              <div className="fk-print">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                        <span className="mt-2 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                          Sales Summary Report
                        </span>
                        {
                          newSalesSummaryReport && newSalesSummaryReport?.branch && (
                            <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                              {newSalesSummaryReport.branch?.name}
                            </span>
                          )
                        }
                        <div>
                          <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                          FROM&nbsp;
                          <Moment format="LL">
                              {startDate}
                            </Moment>&nbsp;{time.fromTime ? time.fromTime.format('hh:mm A') : null}
                            &nbsp;TO&nbsp;
                            <Moment format="LL">{endDate}</Moment>&nbsp;{time.toTime ? time.toTime.format('hh:mm A') : null}
                          </span>
                        </div>
                      <div>
                        <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                          Print Time:{" "} 
                          <Moment format="LLL">
                            {new Date()}
                          </Moment>
                        </span>
                      </div>
                      <div>
                        <span className="mt-1 mb-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                          New Shift Detail
                        </span>
                      </div>
                      {/*ordertype catg wise report */}
                      <div className="col-12">
                        {
                          zReportData &&
                          zReportData !== null && (
                        <div>
                          <p className="mb-1 xsm-text fk-print-text_pos text-capitalize d-flex justify-content-between border border-dark mx-1 font-weight-bold border-1">
                            <span className="font-weight-bold mx-2" style={{width:"40.5%"}}>
                            {zReportData &&
                              zReportData !== null &&
                              "Sales Summary"}
                            </span>
                            
                            <span className="font-weight-bold mx-2"  style={{width:"22.5%"}}>
                            {zReportData &&
                              zReportData !== null &&
                              "Amt"}
                            </span>
              
                            <span className="font-weight-bold mx-2" style={{width:"19%"}}>
                          
                            {zReportData &&
                              zReportData !== null &&
                              "Inv Count"}
                            </span>
              
                            <span className="font-weight-bold mx-2" style={{width:"18%",textAlign:"right"}}>
                            {zReportData &&
                              zReportData !== null &&
                              "Avg"}
                            </span>
                          </p>
                        </div>
                        )}
                      
                        {
                          zReportData && zReportData["Sales Summary"] && typeof(zReportData["Sales Summary"]) === "object" && Object.values(zReportData["Sales Summary"])?.length > 0 &&(
                            <div>
                              {
                                Object.keys(zReportData["Sales Summary"]).map((report,index)=>{
                                  let avg = zReportData["Sales Summary"][report].count !== 0 ? zReportData["Sales Summary"][report].amount / zReportData["Sales Summary"][report].count : 0;
                                  salesAvg += avg;
                                  salesAmount += parseFloat(zReportData["Sales Summary"][report].amount);
                                  salesCount += zReportData["Sales Summary"][report].count
                                return(
                                  <div className={`mb-0 fk-print-text_pos sm-text  text-capitalize d-flex justify-content-between w-100 ${index === Object.values(zReportData["Sales Summary"]).length - 1 && "border border-1 border-dark mb-1 fk-print-text_pos--bold"}`}>
                                    <span className="mx-2 " style={{width:"41%"}}>{report}</span>
                                    <span className="mx-2 " style={{width:"24%"}}>{roundOffPrice(zReportData["Sales Summary"][report].amount)}</span>
                                    <span className="mx-2 " style={{width:"17%"}}>{zReportData["Sales Summary"][report].count}</span>
                                    <span className="mx-2 " style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                  </div>
                                )
                              })
                              }
                              {
                                /*
                              
                              <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"41%"}}>Total</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"24%"}}>{salesAmount.toFixed(2)}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"17%"}}>{salesCount}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"18%",textAlign:"right"}}>{salesAvg.toFixed(0)}</span>
                              </div>
                                */
                              }
                            </div>
                          ) 
                        }

                        {
                          zReportData && zReportData["Sales Payments"] && typeof(zReportData["Sales Payments"]) === "object" && Object.values(zReportData["Sales Payments"])?.length > 0 && (
                            <div className="w-100 col-12 ">
                            <span className="mx-2 d-flex fk-print-text_pos font-weight-bold justify-content-start print-text">Sales Payments</span>

                              { Object.keys(zReportData["Sales Payments"]).map((report,i)=>{
                                let total =parseFloat(zReportData["Sales Payments"][report]["Gross Sales"]) + parseFloat(zReportData["Sales Payments"][report]["Delivery Charges"])
                                + parseFloat(zReportData["Sales Payments"][report]["Sales Tax"]) - parseFloat(zReportData["Sales Payments"][report]["Total Discount"]) - parseFloat(zReportData["Sales Payments"][report]["Refund"]);
                                salesBreakUp += total;
                                return(
                                  <>
                                    <span className="mx-2 d-flex fk-print-text_pos font-weight-md justify-content-center border-dark border-bottom border-1 print-text border-top">{report}</span>
                                    <div className="mb-0 sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100">
                                      <span className="mx-2"  style={{width:"41%"}}>Gross Sales</span>
                                      <span className="mx-2"  style={{width:"24%"}}>{roundOffPrice(zReportData["Sales Payments"][report]["Gross Sales"])}</span>
                                      <span className="mx-2"  style={{width:"17%"}}>0</span>
                                      <span className="mx-2"  style={{width:"18%",textAlign:"right"}}>0</span>
                                    </div>
                                    <div className="mb-0 sm-text fk-print-text_pos  text-capitalize d-flex justify-content-between w-100">
                                      <span className="mx-2"  style={{width:"41%"}}>Total Discount</span>
                                      <span className="mx-2"  style={{width:"24%"}}>{roundOffPrice(zReportData["Sales Payments"][report]["Total Discount"])}</span>
                                      <span className="mx-2"  style={{width:"17%"}}>0</span>
                                      <span className="mx-2"  style={{width:"18%",textAlign:"right"}}>0</span>
                                    </div>
                                    <div className="mb-0 sm-text fk-print-text_pos  text-capitalize d-flex justify-content-between w-100">
                                      <span className="mx-2"  style={{width:"41%"}}>Delivery Charges</span>
                                      <span className="mx-2"  style={{width:"24%"}}>{roundOffPrice(zReportData["Sales Payments"][report]["Delivery Charges"])}</span>
                                      <span className="mx-2"  style={{width:"17%"}}>0</span>
                                      <span className="mx-2"  style={{width:"18%",textAlign:"right"}}>0</span>
                                    </div>
                                    <div className="mb-0 sm-text fk-print-text_pos  text-capitalize d-flex justify-content-between w-100">
                                      <span className="mx-2 "  style={{width:"41%"}}>Sales Tax</span>
                                      <span className="mx-2 "  style={{width:"24%"}}>{roundOffPrice(zReportData["Sales Payments"][report]["Sales Tax"])}</span>
                                      <span className="mx-2 "  style={{width:"17%"}}>0</span>
                                      <span className="mx-2 "  style={{width:"18%",textAlign:"right"}}>0</span>
                                    </div>
                                    <div className="mb-0 sm-text fk-print-text_pos  text-capitalize d-flex justify-content-between w-100">
                                      <span className="mx-2 "  style={{width:"41%"}}>Refund</span>
                                      <span className="mx-2 "  style={{width:"24%"}}>{roundOffPrice(zReportData["Sales Payments"][report]["Refund"])}</span>
                                      <span className="mx-2 "  style={{width:"17%"}}>0</span>
                                      <span className="mx-2 "  style={{width:"18%",textAlign:"right"}}>0</span>
                                    </div>
                                    <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                      <span className="mx-2 fk-print-text_pos--bold"  style={{width:"41%"}}>Total</span>
                                      <span className="mx-2 fk-print-text_pos--bold"  style={{width:"24%"}}>{roundOffPrice(total)}</span>
                                      <span className="mx-2 fk-print-text_pos--bold"  style={{width:"17%"}}>0</span>
                                      <span className="mx-2 fk-print-text_pos--bold"  style={{width:"18%",textAlign:"right"}}>0</span>
                                    </div>
                                  </>
                                  )
                                })
                              }
                              <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"41%"}}>Total</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"24%"}}>{roundOffPrice(salesBreakUp)}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"17%"}}>0</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"18%",textAlign:"right"}}>0</span>
                              </div>
                            </div> 
                          )
                        }

                        {
                          zReportData && zReportData["Discount Summary Claim"] && typeof(zReportData["Discount Summary Claim"]) === "object" && Object.values(zReportData["Discount Summary Claim"])?.length > 0 && (
                            <div className="w-100 col-12 ">
                            <span className="mx-2 d-flex fk-print-text_pos font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">Discount Summary Claim</span>

                              { Object.keys(zReportData["Discount Summary Claim"]).map((report)=>{
                                  let avg = zReportData["Discount Summary Claim"][report].count !== 0 ? parseFloat(zReportData["Discount Summary Claim"][report].amount) / zReportData["Discount Summary Claim"][report].count : 0;
                                  disAvg += avg;
                                  disAmount += parseFloat(zReportData["Discount Summary Claim"][report].amount);
                                  disCount += zReportData["Discount Summary Claim"][report].count;
                                  
                                  return(
                                    <div className="mb-0 sm-text fk-print-text_pos  text-capitalize d-flex justify-content-between w-100">
                                      <span className="mx-2 "  style={{width:"41%"}}>{report}</span>
                                      <span className="mx-2 "  style={{width:"24%"}}>{roundOffPrice(zReportData["Discount Summary Claim"][report].amount)}</span>
                                      <span className="mx-2 "  style={{width:"17%"}}>{zReportData["Discount Summary Claim"][report].count}</span>
                                      <span className="mx-2 "  style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                    </div>
                                  )
                                })
                              }
                              <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"41%"}}>Total</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"24%"}}>{roundOffPrice(disAmount)}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"17%"}}>{disCount}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"18%",textAlign:"right"}}>{(disAmount/disCount).toFixed(0)}</span>
                              </div>
                            </div> 
                          )
                        }

                        {
                          zReportData && zReportData["Discount Summary UnClaim"] && typeof(zReportData["Discount Summary UnClaim"]) === "object" && Object.values(zReportData["Discount Summary UnClaim"])?.length > 0 && (
                            <div className="w-100 col-12 ">
                            <span className="mx-2 d-flex fk-print-text_pos font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">Discount Summary UnClaim</span>

                              { Object.keys(zReportData["Discount Summary UnClaim"]).map((report)=>{
                                  let avg = zReportData["Discount Summary UnClaim"][report].count !== 0 ? parseFloat(zReportData["Discount Summary UnClaim"][report].amount) / zReportData["Discount Summary UnClaim"][report].count : 0;
                                  disUnclaimAvg += avg;
                                  disUnclaimAmount += parseFloat(zReportData["Discount Summary UnClaim"][report].amount);
                                  disUnclaimCount += zReportData["Discount Summary UnClaim"][report].count;
                                  
                                  return(
                                    <div className="mb-0 sm-text fk-print-text_pos  text-capitalize d-flex justify-content-between w-100">
                                      <span className="mx-2 "  style={{width:"41%"}}>{report}</span>
                                      <span className="mx-2 "  style={{width:"24%"}}>{roundOffPrice(zReportData["Discount Summary UnClaim"][report].amount)}</span>
                                      <span className="mx-2 "  style={{width:"17%"}}>{zReportData["Discount Summary UnClaim"][report].count}</span>
                                      <span className="mx-2 "  style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                    </div>
                                  )
                                })
                              }
                              <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"41%"}}>Total</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"24%"}}>{roundOffPrice(disUnclaimAmount)}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"17%"}}>{disUnclaimCount}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"18%",textAlign:"right"}}>{(disUnclaimAmount/disUnclaimCount).toFixed(0)}</span>
                              </div>
                            </div> 
                          )
                        }
                        
                        {
                          zReportData && zReportData["un_tender_summary"] && typeof(zReportData["un_tender_summary"]) === "object" && Object.values(zReportData["un_tender_summary"])?.length > 0 && (
                            <div className="w-100 col-12 ">
                              <span className="mx-2 d-flex fk-print-text_pos font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">UnTender Summary</span>

                                { Object.keys(zReportData["un_tender_summary"]).map((report)=>{
                                    let avg = zReportData["un_tender_summary"][report].count !== 0 ? parseFloat(zReportData["un_tender_summary"][report].amount) / zReportData["un_tender_summary"][report].count : 0;
                                    tenderAvg += avg;
                                    tenderAmount +=  parseFloat(zReportData["un_tender_summary"][report].amount);;
                                    tenderCount += zReportData["un_tender_summary"][report].count;
                                    
                                    return(
                                      <div className="mb-0 sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100">
                                        <span className="mx-2 "  style={{width:"41%"}}>{report}</span>
                                        <span className="mx-2 "  style={{width:"24%"}}>{roundOffPrice(zReportData["un_tender_summary"][report].amount)}</span>
                                        <span className="mx-2 "  style={{width:"17%"}}>{zReportData["un_tender_summary"][report].count}</span>
                                        <span className="mx-2 "  style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                      </div>
                                    )
                                  })
                                }
                              
                              <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"41%"}}>Total</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"24%"}}>{roundOffPrice(tenderAmount)}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"17%"}}>{tenderCount}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"18%",textAlign:"right"}}>{(tenderAmount/tenderCount).toFixed(0)}</span>
                              </div>
                            </div> 
                          )
                        }

                        {
                          zReportData && zReportData["Sales Type"] && typeof(zReportData["Sales Type"]) === "object" && Object.values(zReportData["Sales Type"])?.length > 0 &&(
                            <div className="w-100 col-12 ">
                              <span className="mx-2 d-flex fk-print-text_pos font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">Sales Type</span>
                          
                              { Object.keys(zReportData["Sales Type"]).map((report)=>{
                                  let avg = zReportData["Sales Type"][report].count !== 0 ? parseFloat(zReportData["Sales Type"][report].amount) / zReportData["Sales Type"][report].count : 0;
                                  saleTypeAvg += avg;
                                  saleTypeAmount += parseFloat(zReportData["Sales Type"][report].amount);
                                  saleTypeCount += zReportData["Sales Type"][report].count;
                                  return(
                                    <div className="mb-0 sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100">
                                    <span className="mx-2 "  style={{width:"41%"}}>{report}</span>
                                    <span className="mx-2 "  style={{width:"24%"}}>{roundOffPrice(zReportData["Sales Type"][report].amount)}</span>
                                    <span className="mx-2 "  style={{width:"17%"}}>{zReportData["Sales Type"][report].count}</span>
                                    <span className="mx-2 "  style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                    </div>
                                  )
                                })
                              }
                              <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"41%"}}>Total</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"24%"}}>{roundOffPrice(saleTypeAmount)}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"17%"}}>{saleTypeCount}</span>
                                <span className="mx-2 fk-print-text_pos--bold"  style={{width:"18%",textAlign:"right"}}>{(saleTypeAmount/saleTypeCount).toFixed(0)}</span>
                              </div>
                            </div> 
                          )
                        }


                        {
                          zReportData && zReportData["Delivery Breakup"] && typeof(zReportData["Delivery Breakup"]) === "object" && Object.keys(zReportData["Delivery Breakup"])?.length > 0 &&(
                            <div className="w-100 col-12 ">
                            <span className="mx-2 d-flex fk-print-text_pos  font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">Delivery Breakup</span>

                            { Object.keys(zReportData["Delivery Breakup"]).map((report)=>{
                                let avg = zReportData["Delivery Breakup"][report].count !== 0 ? parseFloat(zReportData["Delivery Breakup"][report].amount) / zReportData["Delivery Breakup"][report].count : 0;
                                deliveryAvg += avg;
                                deliveryAmount += parseFloat(zReportData["Delivery Breakup"][report].amount);
                                deliveryCount += zReportData["Delivery Breakup"][report].count;
                                return(
                                  <div className="mb-0 sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100">
                                  <span className="mx-2 " style={{width:"41%"}}>{report}</span>
                                  <span className="mx-2 " style={{width:"24%"}}>{roundOffPrice(zReportData["Delivery Breakup"][report].amount)}</span>
                                  <span className="mx-2 " style={{width:"17%"}}>{zReportData["Delivery Breakup"][report].count}</span>
                                  <span className="mx-2 " style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                  </div>
                                )
                              })
                            }

                            <div className=" sm-text fk-print-text_pos  text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"41%"}}>Total</span>
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"24%"}}>{roundOffPrice(deliveryAmount)}</span>
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"17%"}}>{deliveryCount}</span>
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"18%",textAlign:"right"}}>{(deliveryAmount/deliveryCount).toFixed(0)}</span>
                            </div>
                          </div> 
                          )
                        }

                        {
                          zReportData && zReportData["Payment Mode"] && typeof(zReportData["Payment Mode"]) === "object" && Object.values(zReportData["Payment Mode"])?.length > 0 &&(
                            <div className="w-100 col-12 ">
                            <span className="mx-2 d-flex fk-print-text_pos  font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">Payment Mode</span>

                            { Object.keys(zReportData["Payment Mode"]).map((report)=>{
                                let avg = zReportData["Payment Mode"][report].count !== 0 ?  parseFloat(zReportData["Payment Mode"][report].amount) / zReportData["Payment Mode"][report].count : 0;
                                paymentModeAvg += avg;
                                paymentModeAmount += parseFloat(zReportData["Payment Mode"][report].amount);
                                paymentModeCount += zReportData["Payment Mode"][report].count ;
                                return(
                                  <div className="mb-0 sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100">
                                    <span className="mx-2 " style={{width:"41%"}}>{report}</span>
                                    <span className="mx-2 " style={{width:"24%"}}>{roundOffPrice(zReportData["Payment Mode"][report].amount)}</span>
                                    <span className="mx-2 " style={{width:"17%"}}>{zReportData["Payment Mode"][report].count}</span>
                                    <span className="mx-2 " style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                  </div>
                                )
                              })
                            }
                            <div className=" sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"41%"}}>Total</span>
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"24%"}}>{roundOffPrice(paymentModeAmount)}</span>
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"17%"}}>{paymentModeCount}</span>
                              <span className="mx-2 fk-print-text_pos--bold" style={{width:"18%",textAlign:"right"}}>{(paymentModeAmount/paymentModeCount).toFixed(0)}</span>
                            </div>
                        </div> 
                        )
                      }

                    
                        {
                          zReportData && zReportData["Payments"] && typeof(zReportData["Payments"]) === "object" && Object.values(zReportData["Payments"])?.length > 0 && Object.keys(zReportData["Payments"]).map((report,index)=>{
                            let paymentAvg = 0;
                            let paymentAmount = 0;
                            let paymentCount = 0;
                            return(
                              <div className="w-100 col-12" key={index}>
                              <span className="mx-2 d-flex fk-print-text_pos font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">{report}</span>
                              {
                                typeof(zReportData["Payments"][report]) === "object" && Object.keys(zReportData["Payments"][report]).map((payment)=>{
                                  let avg = zReportData["Payments"][report][payment].count !== 0 ?  parseFloat(zReportData["Payments"][report][payment].amount) / zReportData["Payments"][report][payment].count : 0;
                                  paymentAvg += avg;
                                  paymentAmount += parseFloat(zReportData["Payments"][report][payment].amount);
                                  paymentCount += zReportData["Payments"][report][payment].count;
                                  return(
                                    <div className="mb-0 sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100">
                                    <span className="mx-2 " style={{width:"41%"}}>{payment}</span>
                                    <span className="mx-2 " style={{width:"24%"}}>{roundOffPrice(zReportData["Payments"][report][payment].amount)}</span>
                                    <span className="mx-2 " style={{width:"17%"}}>{zReportData["Payments"][report][payment].count}</span>
                                    <span className="mx-2 " style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                                    </div>
                                  )
                                })
                              }
                              <div className="sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100 border-1 border border-dark mb-1">
                                  <span className="mx-2 fk-print-text_pos--bold" style={{width:"41%"}}>Total</span>
                                  <span className="mx-2 fk-print-text_pos--bold" style={{width:"24%"}}>{roundOffPrice(paymentAmount)}</span>
                                  <span className="mx-2 fk-print-text_pos--bold" style={{width:"17%"}}>{paymentCount}</span>
                                  <span className="mx-2 fk-print-text_pos--bold" style={{width:"18%",textAlign:"right"}}>{(paymentAmount/paymentCount).toFixed(0)}</span>
                              </div>
                            </div>
                          )})
                        }

                        {
                          zReportData && zReportData["Void Summary"] && typeof(zReportData["Void Summary"]) === "object" && (
                            <div className="w-100 col-12 ">
                            <span className="mx-2 d-flex fk-print-text_pos  font-weight-bold justify-content-start border-dark border-bottom border-1 print-text">Void Summary</span>
                            </div> 
                          )
                        }

                        {
                          zReportData && zReportData["Void Summary"] && typeof(zReportData["Void Summary"]) === "object" && Object.keys(zReportData["Void Summary"]).map((report)=>{
                            let avg = zReportData["Void Summary"][report].count !== 0 ?  parseFloat(zReportData["Void Summary"][report].amount) / zReportData["Void Summary"][report].count : 0
                            return(
                              <div className="mb-0 sm-text fk-print-text_pos text-capitalize d-flex justify-content-between w-100">
                              <span className="mx-2 " style={{width:"41%"}}>{report}</span>
                              <span className="mx-2 " style={{width:"24%"}}>{roundOffPrice(zReportData["Void Summary"][report].amount)}</span>
                              <span className="mx-2 " style={{width:"17%"}}>{zReportData["Void Summary"][report].count}</span>
                              <span className="mx-2 " style={{width:"18%",textAlign:"right"}}>{avg.toFixed(0)}</span>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div> 
                  </div> 
                </div> 
              </div> 
            )
          }
        </div> 
      </div> 
     
      {/* Print Button */}
      <div className="d-none">
        <div>
        {
          /*  
  
          <style type="text/css" media="print">
            {
              "\
          @page { size: landscape; }\
        "
            }
          </style>
          */}
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null && reportData &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="46" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Sales Summary Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                  ></th>
                                  <th
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Order Date"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Created Date"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Token"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Order No"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Punching Time"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Dispatch Time"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Branch Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Party Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Customer Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Customer Phone No"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Customer Address"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Rider Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Ref No"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Payment Type 1"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Payment Type 2"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Bank Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Card No"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Scheme"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Discount"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Gross After Discount"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Discount Claimable"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Discount Unclaimable"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Vat"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Delivery Charges"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Service Charges"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Total"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("POS Service Fee"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Order Tip"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Total Guest"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Order Taker Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Edit By"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cancelled By / Refund By"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("User Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Status"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Reason"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Order Source"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Request From"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Order Notes"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Waiter Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Table Name"))}
                                  </th>
                                  <th
                                  >
                                    {_t(t("Discount Voucher"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                
                                {/* loop here*/}
                                {Object.keys(reportData).map(
                                  (group_name, index) => {
                                    let sum = 0;
                                    let g_total = 0;
                                    let discount = 0;
                                    let delCharges = 0;
                                    let serCharges = 0;
                                    let afterDiscount = 0;
                                    let order_tip = 0;
                                    let pos_fee = 0;
                                    let total_guest = 0;
                                    let tax_total = 0;
                                    return (
                                      <div key={index}>
                                        <tr>
                                          <th
                                            scope="row"
                                          >
                                            {group_name}
                                          </th>
                                        </tr>
                                        {reportData[group_name].map(
                                          (item, i) => {
                                            sum += parseFloat(item.order_bill);
                                            total_price += parseFloat(
                                              item.order_bill
                                            );
                                            g_total += parseFloat(
                                              item.total_payable
                                            );
                                            grand_total += parseFloat(
                                              item.total_payable
                                            );
                                            tax_total += parseFloat(item.vat);
                                            g_tax += parseFloat(item.vat)
                                            g_discount += parseFloat(item.discount_amount)
                                            g_delCharges += parseFloat(item.delivery_charges);
                                            g_serCharges += item.service_amount ? parseFloat(item.service_amount) : 0;
                                            discount += parseFloat(item.discount_amount);
                                            delCharges += parseFloat(item.delivery_charges);
                                            serCharges += parseFloat(item.service_amount);
                                            afterDiscount += parseFloat(item.gross_after_discount);
                                            g_afterDiscount += parseFloat(item.gross_after_discount);
                                            order_tip += parseFloat(item?.order_tip);
                                            g_order_tip += parseFloat(item?.order_tip);
                                            pos_fee += parseFloat(item?.fee);
                                            g_pos_fee += parseFloat(item?.fee);
                                            total_guest += parseFloat(item?.total_guest);
                                            g_total_guest += parseFloat(item?.total_guest);

                                            return (
                                              <tr>
                                                <td></td>
                                                <td>
                                                  {i + 1}
                                                </td>
                                                <td>
                                                  {item.order_date}
                                                </td>
                                                <td>
                                                  {item.created_at}
                                                </td>
                                                <td>
                                                  {item.token.id}
                                                </td>
                                                <td>
                                                  {item.order_no}
                                                </td>
                                                <td>
                                                  {item.punching_time}
                                                </td>
                                                <td>
                                                  {item.ready_time}
                                                </td>
                                                <td>
                                                  {item.branch_name}
                                                </td>
                                                <td>
                                                  {item.order_type_name}
                                                </td>
                                                <td>
                                                  {item.party_name}
                                                </td>
                                                <td>
                                                  {item.customer_name}
                                                </td>
                                                <td>
                                                  {item?.delivery_phn_no}
                                                </td>
                                                <td>
                                                  {item.customer_address}
                                                </td>
                                                <td>
                                                  {item.delivery_boy_name}
                                                </td>
                                                <td>
                                                  {item.ref_no}
                                                </td>
                                                <td>
                                                  {item.bill_distribution[0]
                                                    ? item.bill_distribution[0].name
                                                    : "-"}
                                                </td>
                                                <td>
                                                  {item.bill_distribution[0]
                                                    ? item.bill_distribution[0].value
                                                    : "0"}
                                                </td>
                                                <td>
                                                  {item.bill_distribution[1]
                                                    ? item.bill_distribution[1].name
                                                    : "-"}
                                                </td>
                                                <td>
                                                  {item.bill_distribution[1]
                                                    ? item.bill_distribution[1].value
                                                    : "0"}
                                                </td>
                                                <td>
                                                  {item.bank_name ? item.bank_name : "-"}
                                                </td>
                                                <td>
                                                  {item.payment_card_number}
                                                </td>
                                                <td>
                                                  {item.scheme_name}
                                                </td>
                                                <td>
                                                  {item.order_bill}
                                                </td>
                                                <td>
                                                  {item.discount_amount}
                                                </td>
                                                <td>
                                                  {item.gross_after_discount}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.claimable_amount}
                                                </td>
                                                <td>
                                                  {item.unclaimable_amount}
                                                </td>
                                                <td>
                                                  {item.vat}
                                                </td>
                                                <td>
                                                  {item.delivery_charges}
                                                </td>
                                                <td>
                                                  {item.service_amount}
                                                </td>
                                                <td
                                                >
                                                  {item.total_payable}
                                                </td>
                                                <td
                                                >
                                                  {item.fee}
                                                </td>
                                                <td
                                                >
                                                  {item?.order_tip}
                                                </td>
                                                <td
                                                >
                                                  {item?.total_guest}
                                                </td>
                                                <td
                                                scope="row"
                                                >
                                                  {item?.order_taker_name || "-"}
                                                </td>
                                                <td>
                                                  {item?.edit_by_name || "-"}
                                                </td>
                                                <td>
                                                  {item?.cancelled_by_name || "-"}
                                                </td>
                                                <td
                                                >
                                                  {item.user_name}
                                                </td>
                                                <td>
                                                {parseInt(
                                                    item.is_cancelled
                                                  ) === 0 ? (
                                                    [
                                                      parseInt(
                                                        item.is_ready
                                                      ) === 1 &&
                                                      parseInt(
                                                        item.is_refund
                                                      ) === 0 && parseInt(item.is_foc) === 0 ? (
                                                        <span>
                                                          {_t(t("Ready"))}
                                                        </span>
                                                      ) : parseInt(
                                                          item.is_refund
                                                        ) === 1 && parseInt(item.is_foc) === 0 ? (
                                                        <span>
                                                          {_t(t("Refund"))}
                                                        </span>
                                                      ) : 
                                                      parseInt(item.is_foc) === 1 ?(
                                                        <span>
                                                        {_t(t("Free of cost"))}
                                                        </span>
                                                      ) :
                                                      (
                                                        <span>
                                                          {_t(t("processing"))}
                                                        </span>
                                                      ),
                                                    ]
                                                  ) : (
                                                    <span>
                                                      {_t(t("Cancelled"))}
                                                    </span>
                                                  )}
                                                </td>
                                                <td
                                                >
                                                  {item.reason ? item.reason : "-"}
                                                </td>
                                                <td
                                                >
                                                  {item.order_source ? item.order_source : "-"}
                                                </td>
                                                <td
                                                >
                                                  {item.request_from ? item.request_from : "-"}
                                                </td>
                                                <td
                                                >
                                                  {item?.note_to_rider ? item.note_to_rider : "-"}
                                                </td>
                                                <td
                                                >
                                                  {item.waiter_name ? item.waiter_name : "-"}
                                                </td>
                                                <td
                                                >
                                                  {item.table_name}
                                                </td>
                                                <td>{item?.discount_voucher}</td>
                                              </tr>
                                            );
                                          }
                                        )}
                                        <tr>
                                          <th colspan="22"></th>
                                          <th>
                                            Total
                                          </th>
                                          <td>
                                            {roundFormatPrice(sum)}
                                          </td>
                                          <td>{discount}</td>
                                          <td>{afterDiscount}</td>
                                          <td></td>
                                          <td></td>
                                          <td>
                                            {roundFormatPrice(tax_total)}
                                          </td>
                                          <td>{delCharges}</td>
                                          <td>{serCharges}</td>
                                          <td>
                                            {roundFormatPrice(g_total)}
                                          </td>
                                          <td>{pos_fee}</td>
                                          <td>
                                            {roundFormatPrice(order_tip)}
                                          </td>
                                          <td>
                                            {roundFormatPrice(total_guest)}
                                          </td>
                                        </tr>
                                      </div>
                                    );
                                  }
                                )}
                                {
                                 <>
                                  <tr>
                                    <th colspan="22"></th>
                                    <th>
                                      Grand Total
                                    </th>
                                    <td>
                                      {roundFormatPrice(total_price)}
                                    </td>
                                    <td>{g_discount}</td>
                                    <td>{g_afterDiscount}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{roundFormatPrice(g_tax)}</td>
                                    <td>{g_delCharges}</td>
                                    <td>{g_serCharges}</td>
                                    <td>
                                      {roundFormatPrice(grand_total)}
                                    </td>
                                    <td>{g_pos_fee}</td>
                                    <td>
                                      {roundFormatPrice(g_order_tip)}
                                    </td>
                                    <td>
                                      {roundFormatPrice(g_total_guest)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th colspan="23"></th>
                                    <td>
                                      Gross Amount
                                    </td>
                                    <td>Discount</td>
                                    <td>After Discount</td>
                                    <td></td>
                                    <td></td>
                                    <td>Vat</td>
                                    <td>D.C</td>
                                    <td>S.C</td>
                                    <td>
                                      Total
                                    </td>
                                    <td>
                                      Pos Service Fee
                                    </td>
                                    <td>
                                      Order Tip
                                    </td>
                                    <td>
                                      Total Guest
                                    </td>
                                  </tr>
                                 </>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button thermal */}
      <div className="d-none">
        <div ref={componentRefThermalDetail}>
          <div className="fk-print">
            <div className="container-fuild">
              <div className="row">
                <div className="col-12">
                  {reportData !== null && reportData &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="20" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Sales Summary Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Order Date"))}
                                  </th>
                                  <th className="border border-1 table_child_token"
                                  >
                                    {_t(t("Token"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Punching Time"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Branch Name"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Party Name"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Customer Name"))}
                                  </th>
                                  {/* <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Payment Type 1"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Payment Type 2"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Amount"))}
                                  </th> */}
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Order Bill"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Vat"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Discount"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Total"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Order Taker Name"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Edit By"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Cancelled By / Refund By"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Status"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="border border-1 align-middle">
                                
                                {/* loop here*/}
                                {Object.keys(reportData).map(
                                  (group_name, index) => {
                                    let sum = 0;
                                    let total = 0;
                                    let tax = 0
                                    return (
                                      <>
                                        {/* <tr>
                                          <th
                                            scope="row"
                                          >
                                            {group_name}
                                          </th>
                                        </tr> */}
                                        {reportData[group_name].map(
                                          (item, i) => {
                                            sum += parseFloat(item.order_bill);
                                            tax += parseFloat(item.vat);
                                            grandTotalTax += parseFloat(item.vat);
                                            grandOrderBill += parseFloat(
                                              item.order_bill
                                            );
                                            total += Number(item.total_payable);
                                            grandTotal += parseFloat(
                                              item.total_payable
                                            );

                                            return (
                                              <tr>
                                                <td>
                                                  {item.order_date}
                                                </td>
                                                <td>
                                                  {item.token.id}
                                                </td>
                                                <td>
                                                  {item.punching_time}
                                                </td>
                                                <td>
                                                  {item.branch_name}
                                                </td>
                                                <td>
                                                  {item.order_type_name}
                                                </td>
                                                <td>
                                                  {item.party_name}
                                                </td>
                                                <td>
                                                  {item.customer_name}
                                                </td>
                                                {/* <td>
                                                  {item.bill_distribution[0]
                                                    ? item.bill_distribution[0].name
                                                    : "-"}
                                                </td>
                                                <td>
                                                  {item.bill_distribution[0]
                                                    ? item.bill_distribution[0].value
                                                    : "0"}
                                                </td>
                                                <td>
                                                  {item.bill_distribution[1]
                                                    ? item.bill_distribution[1].name
                                                    : "-"}
                                                </td>
                                                <td>
                                                  {item.bill_distribution[1]
                                                    ? item.bill_distribution[1].value
                                                    : "0"}
                                                </td> */}
                                                <td
                                                >
                                                  {item?.order_bill}
                                                </td>
                                                <td>
                                                  {item?.vat}
                                                </td>
                                                <td>
                                                  {item?.discount_amount}
                                                </td>
                                                <td
                                                >
                                                  {item.total_payable}
                                                </td>
                                                <td
                                                scope="row"
                                                >
                                                  {item?.order_taker_name || "-"}
                                                </td>
                                                <td>
                                                  {item?.edit_by_name || "-"}
                                                </td>
                                                <td>
                                                  {item?.cancelled_by_name || "-"}
                                                </td>
                                                <td>
                                                {parseInt(
                                                    item.is_cancelled
                                                  ) === 0 ? (
                                                    [
                                                      parseInt(
                                                        item.is_ready
                                                      ) === 1 &&
                                                      parseInt(
                                                        item.is_refund
                                                      ) === 0 && parseInt(item.is_foc) === 0 ? (
                                                        <span>
                                                          {_t(t("Ready"))}
                                                        </span>
                                                      ) : parseInt(
                                                          item.is_refund
                                                        ) === 1 && parseInt(item.is_foc) === 0 ? (
                                                        <span>
                                                          {_t(t("Refund"))}
                                                        </span>
                                                      ) : 
                                                      parseInt(item.is_foc) === 1 ?(
                                                        <span>
                                                        {_t(t("Free of cost"))}
                                                        </span>
                                                      ) :
                                                      (
                                                        <span>
                                                          {_t(t("processing"))}
                                                        </span>
                                                      ),
                                                    ]
                                                  ) : (
                                                    <span>
                                                      {_t(t("Cancelled"))}
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                        <tr>
                                          <th colspan="6"></th>
                                          <th>
                                            Total
                                          </th>
                                          <td>
                                            {roundFormatPrice(sum)}
                                          </td>
                                          <td>
                                            {roundFormatPrice(tax)}
                                          </td>
                                          <th colspan="1"></th>
                                          <td>
                                            {roundFormatPrice(total)}
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  }
                                )}
                                {
                                 <>
                                  <tr>
                                    <th colspan="6"></th>
                                    <th>
                                      Grand Total
                                    </th>
                                    <td>{roundFormatPrice(grandOrderBill)}</td>
                                    <td>{roundFormatPrice(grandTotalTax)}</td>
                                    <th colspan="1"></th>
                                    <td>
                                      {roundFormatPrice(grandTotal)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th colspan="7"></th>                                  
                                    <td>
                                      Gross Amount
                                    </td>
                                    <td>
                                      Tax
                                    </td>
                                    <th colspan="1"></th>
                                    <td>
                                      Total
                                    </td>
                                  </tr>
                                 </>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*daily bill sales print */}
      <div className="d-none">
        <div ref={componentRefThermalDaily}>
          {dailyBillReportData && (
            <div className="fk-print">
              <div className="row sm-text">
                <div className="col-12">
                  <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                    Daily Bills Summary
                  </div>
                  <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                    Branch: {newSalesSummaryReport?.branch && newSalesSummaryReport?.branch?.name}
                  </div>
                  <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                    FROM&nbsp;
                    <Moment format="LL">
                      {startDate}
                    </Moment>
                    &nbsp;TO&nbsp;
                    <Moment format="LL">{endDate}</Moment>
                  </div>
                  <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                    Print Date: {moment(new Date()).format('DD-MM-YYYY hh:mm A')}
                  </div>
                </div>
                <div className="col-12">
                  <table className="table table-bordered-sm table-hover">
                    <thead className="align-middle">
                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        S.No
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Token No
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Invoice No
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Tax
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Subtotal
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Discount
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        S.C
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        D.C
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Credit
                      </th>

                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Net Sale
                      </th>

                      {/* <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Payment Type
                      </th> */}
                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Remarks
                      </th>
                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Order Taker Name
                      </th>
                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Edit By
                      </th>
                      <th scope="col"
                        className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "50px", padding:"3.5px"}}>
                        Cancelled By / Refund By
                      </th>
                    </thead>
                    <tbody className="align-middle">                                                        
                      {
                        dailyBillReportData &&
                        dailyBillReportData?.length && dailyBillReportData?.map((item, index)=>{
                          const splitPayment = item?.PaymentTypes?.split(",");
                          splitPayment.forEach((paymentType) => {
                            const [key, value] = paymentType.split(":").map(s => s.trim());
                            if(key && value){
                              if (paymentTypeWise[key]) {
                                paymentTypeWise[key] += Number(value);
                              } else {
                                paymentTypeWise[key] = Number(value);
                              }
                            }
                          })
                          grossAmount += roundOffPrice(item?.orderBill);
                          discount += roundOffPrice(item?.discountAmount);
                          serviceCharge += roundOffPrice(item.serviceAmount)
                          deliveryCharges += roundOffPrice(item?.serviceCharge);
                          tax += roundOffPrice(item?.vat);
                          totalPayable += roundOffPrice(item?.totalPayable);

                          return(
                            <tr>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{index + 1}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.token}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.documentNo}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{roundOffPrice(item?.vat)}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{roundOffPrice(item?.orderBill)}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{roundOffPrice(item?.discountAmount)}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{roundOffPrice(item?.serviceAmount)}</td> 
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{roundOffPrice(item.serviceCharge)}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.credit}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{roundOffPrice(item?.totalPayable)}</td>
                              {/* <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.PaymentTypes}</td> */}
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.remarks}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.order_taker_name || "-"}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.edit_by_name || "-"}</td>
                              <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px", padding:"3.5px"}}>{item?.cancelled_by_name || "-"}</td>
                            </tr>       
                          )
                        })
                      }
                      <tr>
                        <td className="text-capitalize align-middle text-center border font-weight-md" colSpan={3}>Grand Total</td>
                        <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px",}}>{roundOffPrice(tax)}</td>
                        <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px",}}>{roundOffPrice(grossAmount)}</td>
                        <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px",}}>{roundOffPrice(discount)}</td>  
                        <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px",}}>{serviceCharge}</td>
                        <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px",}}>{deliveryCharges}</td>  
                        <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px",}}></td>
                        <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px",}}>{roundOffPrice(totalPayable)}</td>  
                        <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px",}}>{Object.keys(paymentTypeWise)[0]  + ":" + roundOffPrice(paymentTypeWise[Object.keys(paymentTypeWise)[0]])}</td>
                        <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px",}}></td>
                        <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px",}}></td>
                        <td className="text-capitalize align-middle text-center border" style={{ minWidth: "50px",}}></td>
                      </tr>
                      {
                        Object.keys(paymentTypeWise).map((key, index)=>{
                          if(index > 0){
                            return (
                              <tr key={index}>
                                <td className="text-capitalize align-middle text-end border" colSpan={13}></td>
                                <td className="text-capitalize align-middle text-center border font-weight-md" style={{ minWidth: "50px"}}>
                                  {key + ": " + roundOffPrice(paymentTypeWise[key])}
                                </td>
                              </tr>
                            )
                          }
                        })
                      }
                    </tbody>
                  </table>                       
                </div>                   
              </div>
            </div>
          )}
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading <div className={`${dataPaginating && "loading"}`}></div>*/}
                    <CustomSpinLoader loading={loading || dataPaginating}/>
                    
                    {/* spin loading ends */}

                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-6 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Sales Summary Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-6 d-flex justify-content-end p-0">
                          <ReportTypeOptions
                            selectedOption={reportOption}
                            onChange={handleReportOption}
                          />
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-md-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={true}
                            // minDate={getMinDateByTime()}
                          />
                        </div>
                        <div className="col-md-2 t-mb-15 mb-md-0">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={true}
                            // minDate={getMinDateByTime()}
                          />
                        </div>
                        <div className="col-md-4 t-mb-15 mb-md-0">
                          <Select
                            options={branchForSearch ?? []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            classNamePrefix="select"
                            isMulti={option !== "daily_bill_summary"}
                            onChange={handleBranch}
                            value={newSalesSummaryReport?.branch || ""}
                            key={newSalesSummaryReport?.branch}
                            styles={customStyle}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>
                        <div className="col-4 t-mb-15 mb-md-0">
                          <Select
                            options={partyForSearch && partyForSearch}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            isMulti={option === "sales_summary_report"}
                            classNamePrefix="select"
                            styles={customStyle}
                            className="sm-text "
                            value={newSalesSummaryReport?.party ? newSalesSummaryReport.party : null}
                            onChange={handleParty}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a party")) + ".."}
                          />
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <>
                          <div className="d-md-block col-md-2">
                            <Datetime
                              inputProps={inputProp}
                              value={time.fromTime}
                              key={time.key}
                              onChange={(date)=>setTime({...time,fromTime:date})}
                              placeholder="From Time"
                              dateFormat={false} // Hide the date picker
                              className="col"
                              timeConstraints={{
                                minutes: { step: 5 }, // Customize time selection steps
                              }}
                            />
                          </div>
                          <div className="d-md-block col-md-2">
                            
                            <Datetime
                            //input={false} // Hide the input field for time selection only
                            inputProps={inputProps}
                            value={time.toTime}
                            key={time.key}
                            onChange={(date)=>setTime({...time,toTime:date})}
                            placeholder="To Time"
                            dateFormat={false} // Hide the date picker
                            className="col"
                            timeConstraints={{
                              minutes: { step: 5 }, // Customize time selection steps
                            }}
                            />
                          </div>
                        </>

                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={orderTypeList?.data && orderTypeList.data}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            //value={orderTypes}
                            styles={customStyle}
                            classNamePrefix="select"
                            className="sm-text "
                            onChange={handleOrderTypes}
                            value={newSalesSummaryReport && newSalesSummaryReport.orderTypes}
                            key={newSalesSummaryReport?.orderTypes}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a order types")) + ".."}
                          />
                        </div>
                        
                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={
                              paymentTypeForSearch && paymentTypeForSearch
                            }
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            //value={paymentTypes}
                            classNamePrefix="select"
                            className="sm-text "
                            styles={customStyle}
                            value={newSalesSummaryReport && newSalesSummaryReport.paymentTypes}
                            key={newSalesSummaryReport?.paymentTypes}
                            onChange={handlePaymentTypes}
                            maxMenuHeight="200px"
                            placeholder={
                              _t(t("Select a payment type")) + ".."
                            }
                          />
                        </div>
                        <div className="col-md-4 t-mb-15 mb-md-0">
                          <Select
                            options={groupByArray && groupByArray}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.name}
                            isClearable
                            //value={groupBy}
                            styles={customStyle}
                            value={newSalesSummaryReport && newSalesSummaryReport.groupBy}
                            key={newSalesSummaryReport?.groupBy}
                            classNamePrefix="select"
                            className="sm-text "
                            onChange={handleGroupBy}
                            maxMenuHeight="200px"
                            placeholder={
                              _t(t("Select a report group")) + ".."
                            }
                          />
                        </div>
                      </div>
                      <>
                        <div className="row gx-2 justify-content-end t-pb-15 t-pt-15">
                          {/* Action Button */}
                          <div className="d-flex justify-content-end col-10">
                            <div className="mr-4 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="sales_summary_report"
                                name="sales_summary_report"
                                value="sales_summary_report"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "sales_summary_report"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1"
                                htmlFor="sales_summary_report"
                              >
                                {_t(t("Sales Summary Report"))}
                              </label>
                            </div>
                            <div className="mr-4 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="daily_bill_summary"
                                name="daily_bill_summary"
                                value="daily_bill_summary"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "daily_bill_summary"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1"
                                htmlFor="daily_bill_summary"
                              >
                                {_t(t("Daily Bill Summary"))}
                              </label>
                            </div>
                            <div className="mr-4 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="sales_data"
                                name="sales_data"
                                value="sales_data"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "sales_data"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1"
                                htmlFor="sales_data"
                              >
                                {_t(t("Sales Data"))}
                              </label>
                            </div>
                            <div className="mr-4 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="branch_wise_report"
                                name="branch_wise_report"
                                value="branch_wise_report"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "branch_wise_report"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1"
                                htmlFor="branch_wise_report"
                              >
                                {_t(t("Branch Wise Report"))}
                              </label>
                            </div>
                            <div className="mr-4 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="thermal_report"
                                name="thermal_report"
                                value="thermal_report"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "thermal_report"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1"
                                htmlFor="thermal_report"
                              >
                                {_t(t("Thermal Report"))}
                              </label>
                            </div>
                          </div>
                          <div className="col-2 t-mb-15 mb-md-0 text-right">
                            <button
                              className="float-right btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                              onClick={(e) => handleCheckReport(e)}
                            >
                              Print Report
                            </button>
                          </div>
                        </div>
                        {/* )} */}
                      </>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default SalesSummaryReport;
